import Tabs from '../../../js/src/__page/tabs';

const initAgeGroupTabs = () => {
	document.querySelectorAll('.block-age-group-tabs').forEach((block) => {
		const tabLinks = block.querySelectorAll('.tabs__link');
		const panels = block.querySelectorAll('.block-age-group-tabs__panel');
		if (!tabLinks.length || !panels.length) return;

		tabLinks.forEach((li) => {
			const btn = li.querySelector('.tabs_link--inner');
			if (!btn) return;

			btn.addEventListener('click', (e) => {
				e.preventDefault();
				const target = btn.getAttribute('data-target'); // "#0" etc.

				tabLinks.forEach((el) => el.classList.remove('active'));
				panels.forEach((p) => {
					p.classList.toggle('active', p.getAttribute('data-tab-id') === target);
				});
				li.classList.add('active');
			});
		});
	});
};

const initGenderToggles = () => {
	document.querySelectorAll('.block-age-group-tabs__panel').forEach((panel) => {
		const buttons = panel.querySelectorAll('.block-age-group-tabs__gender-btn');
		const genderPanels = panel.querySelectorAll('.block-age-group-tabs__gender-panel');
		if (!buttons.length || !genderPanels.length) return;

		const toggles = panel.querySelectorAll('.block-age-group-tabs__gender-toggle');
		buttons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const gender = btn.getAttribute('data-gender');
				toggles.forEach((t) => t.setAttribute('data-active', gender));
				buttons.forEach((b) => {
					const isActive = b.getAttribute('data-gender') === gender;
					b.classList.toggle('is-active', isActive);
					b.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});
				genderPanels.forEach((p) => {
					const shouldBeActive = p.getAttribute('data-gender') === gender;
					p.classList.toggle('is-active', shouldBeActive);
					if (shouldBeActive) {
						// Re-trigger CSS slide-in animation
						p.style.animation = 'none';
						// force reflow so the animation restarts
						void p.offsetWidth;
						p.style.animation = '';
					}
				});
			});
		});
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		Tabs.init();
		initAgeGroupTabs();
		initGenderToggles();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
